<ng-container *ngIf="showShell">
  <button *ngIf="showFab" type="button" class="unread-fab" (click)="toggle()"
    [attr.aria-label]="mobileOpen ? 'Close unread coaching chats' : 'Open unread coaching chats' + (unreadTotal ? ', ' + unreadTotal + ' unread' : '')"
    [attr.aria-expanded]="mobileOpen" aria-controls="coach-unread-dock">
    <i class="bi bi-inbox-fill" aria-hidden="true"></i>
    <span class="badge" *ngIf="!mobileOpen && unreadTotal > 0" aria-hidden="true">{{ unreadTotal > 99 ? '99+' : unreadTotal }}</span>
  </button>

  <button *ngIf="showStrip" type="button" class="unread-strip" (click)="toggle()"
    [attr.aria-label]="'Open unread coaching chats' + (unreadTotal ? ', ' + unreadTotal + ' unread' : '')"
    aria-expanded="false" aria-controls="coach-unread-dock">
    <i class="bi bi-inbox-fill" aria-hidden="true"></i>
    <span class="strip-label">Unread</span>
    <span class="badge" *ngIf="unreadTotal > 0" aria-hidden="true">{{ unreadTotal > 99 ? '99+' : unreadTotal }}</span>
  </button>

  <aside class="unread-dock" id="coach-unread-dock" *ngIf="showPanel" [class.mobile]="isMobile" [class.desktop]="!isMobile"
    aria-label="Unread coaching conversations">
    <header class="dock-head">
      <div>
        <h3>Unread chats</h3>
        <p>{{ visibleThreads.length ? visibleThreads.length + ' waiting' : 'All caught up' }}</p>
      </div>
      <div class="actions">
        <button type="button" class="icon-btn" (click)="refresh()" [disabled]="loading" aria-label="Refresh" title="Refresh">
          <i class="bi bi-arrow-clockwise" [class.spin]="loading"></i>
        </button>
        <button type="button" class="icon-btn" (click)="close()"
          [attr.aria-label]="isMobile ? 'Close unread chats' : 'Collapse unread chats'" aria-expanded="true">
          <i class="bi" [class.bi-x-lg]="isMobile" [class.bi-chevron-double-right]="!isMobile"></i>
        </button>
      </div>
    </header>

    <div class="dock-body">
      <p class="empty" *ngIf="!loading && !visibleThreads.length">No unread client messages.</p>
      <button type="button" class="row" *ngFor="let t of visibleThreads; trackBy: trackById"
        (click)="openThread(t.thread_id)"
        [attr.aria-label]="(t.assignment.user?.name || 'Unknown') + ', ' + productLineLabel(t.assignment.product_line) + ', ' + unreadFor(t) + ' unread'">
        <span class="avatar" aria-hidden="true">
          <img *ngIf="t.assignment.user?.picture_url" [src]="t.assignment.user?.picture_url" alt="" />
          <span *ngIf="!t.assignment.user?.picture_url">{{ initials(t.assignment.user) }}</span>
        </span>
        <span class="main">
          <span class="name">{{ t.assignment.user?.name || 'Unknown' }}</span>
          <span class="preview">{{ t.last_message?.content || 'New message' }}</span>
          <span class="meta">{{ productLineLabel(t.assignment.product_line) }}</span>
        </span>
        <span class="badge-unread" *ngIf="unreadFor(t)" aria-hidden="true">{{ unreadFor(t) }}</span>
      </button>
    </div>
  </aside>

  <div class="unread-backdrop" *ngIf="isMobile && mobileOpen" (click)="close()" aria-hidden="true"></div>
</ng-container>
